import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AccountInfoActions } from '../../account-info-header/actions';
import { AccountInfo } from '../../account-info-header/models';
import { selectInfo, selectSubAccountId } from '../../account-info-header/reducers';
import { Constants } from '../../shared/utilities/Constants';
import { loadEAuthClients } from '../actions/eAuthorization.actions';
import { selectEauthClientServiceError } from '../reducers';
import { CoreService, ICurrentContext } from '@charlesschwab/sac-ui-core';
import { ContextType } from '@charlesschwab/as-ui-core';
import { selectAuthorizeCallFailed, selectAuthorizeCallSuccessful, selectHasViewMoveMoney } from '../../authorize/reducers';
import { ValidateWireFlagsService } from '../../shared/services/validate-WireFlags.service';

@Component({
  standalone: false,
  selector: 'mm-setup-eAuthorization',
  templateUrl: './setup-eAuthorization.component.html',
  styleUrls: ['./setup-eAuthorization.component.scss']
})
export class SetupEAuthorizationComponent implements OnInit, OnDestroy {
  accountInfo: AccountInfo;
  hasEauthClientsServiceError$: Observable<boolean>;
  destroy$ = new Subject<void>();
  accountInContext: boolean = false;
  hasViewMoneyAccess$: Observable<boolean>;
  authorizedFinished$: Observable<boolean>;
  authorizedFailed$: Observable<boolean>;
  currentContext: ICurrentContext = {
    contextId: 0,
    contextType: ContextType.Unknown,
    firmId: 0,
    firmName: '',
    title: '',
  };

  constructor(private store: Store<{}>,
       private coreService: CoreService,
       private validateWireFlagsService: ValidateWireFlagsService) { }

  ngOnInit(): void {

    this.authorizedFinished$ = this.store.select(selectAuthorizeCallSuccessful);
    this.authorizedFailed$ = this.store.select(selectAuthorizeCallFailed);
    this.authorizedFinished$.pipe(takeUntil(this.destroy$)).subscribe(finished => {
    if (finished){
      this.hasViewMoneyAccess$ = this.store.pipe(select(selectHasViewMoveMoney));
    }
    else {
      this.hasViewMoneyAccess$ = of(false);
    }
    });

    this.hasEauthClientsServiceError$ = this.store.pipe(select(selectEauthClientServiceError));
    this.store.select(selectInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe(accountInfo => {
      this.accountInfo = accountInfo;
    });
    this.store.select(selectSubAccountId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => {
        if (val){
          this.store.dispatch(AccountInfoActions.updateSubAccount({ accountId: val }));
        }
    });
    this.store.dispatch(loadEAuthClients({ accountId: this.accountInfo.accountId }));

    this.coreService.currentContextUpdated$
    .pipe(takeUntil(this.destroy$))
    .subscribe((context) => {
      if (context) {
        this.currentContext = context;
        this.store.dispatch(loadEAuthClients({ accountId: this.accountInfo.accountId }));
      }
      if (this.currentContext?.contextType === ContextType.Account 
        || (this.currentContext?.contextType === ContextType.PALAccount
          && this.validateWireFlagsService.enablePalWireCreateTransaction())) {
        this.accountInContext = true;
      }
      else
      {
        this.accountInContext = false;
      }
    });

    if (this.coreService?.currentContext?.contextType === ContextType.Account 
      || (this.coreService?.currentContext?.contextType === ContextType.PALAccount)
          && this.validateWireFlagsService.enablePalWireCreateTransaction()) {
      this.accountInContext = true;
    }
    else
    {
      this.accountInContext = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  get serviceErrorMessage(): string {
    return Constants.genericServiceError;
  }
}
